module.exports = __webpack_public_path__ + "static/media/store-banner-2.2fdd2f2f.jpeg";